import styled from "styled-components";

export const EmptyWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 32px 20px;
	border-radius: 16px;
	background: var(--input-bg-has-value);
	border: 1px dashed rgba(110, 113, 145, 0.25);
	text-align: center;
	min-height: 140px;
`;

export const EmptyIcon = styled.div`
	width: 44px;
	height: 44px;
	border-radius: 12px;
	background: rgba(99, 179, 237, 0.12);
	border: 1px solid rgba(99, 179, 237, 0.25);
	display: flex;
	align-items: center;
	justify-content: center;

	&::after {
		content: "";
		width: 18px;
		height: 18px;
		border-radius: 4px;
		border: 2px solid rgba(99, 179, 237, 0.6);
		opacity: 0.8;
	}
`;

export const EmptyTitle = styled.div`
	color: var(--content-text-color);
	font-size: 14px;
	font-weight: 600;
`;

export const EmptyDescription = styled.div`
	color: var(--secondary-text-color);
	font-size: 12px;
	line-height: 1.5;
	max-width: 280px;
`;
